import React, { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hideProductDetails } from 'ducks/layout';
import ProductsMenu from './menus/ProductsMenu';
import { getSelectedGroupId } from 'ducks/products';
import { useAppDispatch } from 'ducks/hooks';

// Decides which view that should be visible in the sidebar.
// E.g. Group selection, Product List or Product details
const ProductSidebarContent: React.FunctionComponent<object> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const selectedGroupId = useSelector(getSelectedGroupId);

  const closeProductDetails = useCallback(() => {
    dispatch(hideProductDetails());
  }, [dispatch]);

  useEffect(() => {
    if (history.location.pathname !== '/planner') {
      closeProductDetails();
    }
  }, [closeProductDetails, history.location, history.location.pathname]);

  return <ProductsMenu data-testid={`${selectedGroupId}-menu`} />;
};

export default ProductSidebarContent;
